var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuiz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_61_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5H60C66.3513 0.5 71.5 5.64873 71.5 12V56C71.5 62.3513 66.3513 67.5 60 67.5H16C9.64873 67.5 4.5 62.3513 4.5 56V12C4.5 5.64873 9.64873 0.5 16 0.5Z",
    fill: "#3EC6CA",
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3722 14H21.197C17.781 14 15 16.4444 15 19.4511V41.7648C15 44.7676 17.781 47.21 21.197 47.21H24.8015C24.8015 47.21 22.1491 52.5557 20.9307 55C24.5774 51.8587 29.9641 47.21 29.9641 47.21H54.37C57.7903 47.21 60.5647 44.7676 60.5647 41.7648V19.4511C60.5669 16.4444 57.788 14 54.3722 14ZM38.7689 40.2557C38.3871 40.6012 37.9277 40.775 37.3883 40.775C36.8556 40.775 36.3918 40.6032 36.0145 40.2634C35.6349 39.9218 35.444 39.4981 35.444 39.0003C35.444 38.5239 35.6349 38.1198 36.0145 37.7918C36.394 37.4677 36.8556 37.3037 37.3883 37.3037C37.9277 37.3037 38.3871 37.4677 38.7689 37.7996C39.1439 38.1315 39.3349 38.5278 39.3349 39.0003C39.3349 39.4923 39.144 39.9101 38.7689 40.2557ZM43.5032 27.9869C43.2058 28.5277 42.44 29.2832 41.2281 30.2653C39.6412 31.5187 38.6802 32.4441 38.3383 33.0416C38.0009 33.6391 37.8145 34.6289 37.7834 36.0073H36.9223C36.9223 34.8906 36.9889 34.0041 37.1154 33.3598C37.253 32.7136 37.4283 32.2079 37.6348 31.8311C37.8457 31.4602 38.3828 30.773 39.2418 29.7694C39.921 28.9962 40.3981 28.2641 40.6756 27.5749C40.9442 26.8896 41.0928 26.1281 41.0928 25.3042C41.0928 24.1855 40.7288 23.2835 40.0142 22.5982C39.3062 21.9169 38.425 21.5752 37.3907 21.5752C36.4985 21.5752 35.7593 21.7704 35.16 22.157C34.5585 22.5436 34.2655 22.9418 34.2655 23.3518C34.2655 23.5783 34.4742 23.8361 34.8915 24.1211C35.5174 24.5564 35.837 25.0309 35.837 25.5443C35.837 25.9993 35.6727 26.3838 35.3331 26.6845C34.9957 26.9832 34.5718 27.1374 34.068 27.1374C33.4599 27.1374 32.9493 26.9226 32.5365 26.4932C32.1193 26.0695 31.9106 25.5072 31.9106 24.8141C31.9106 23.7207 32.4832 22.7407 33.6263 21.8699C34.776 21.0011 36.2143 20.5676 37.9521 20.5676C39.741 20.5676 41.2015 21.0499 42.3645 22.0221C43.5231 22.9866 44.1047 24.1698 44.1047 25.5657C44.1068 26.4562 43.9027 27.2664 43.5032 27.9869Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_61_2",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_61_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_61_2",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.00d9358e7f5b24aa4b6cecfbbeb72b9b.svg";
export { ForwardRef as ReactComponent };